import { Check, AlertTriangle, X, Pencil } from "lucide-react";

export const SHORT_LANG = { "es-ES": "ES", "en-GB": "EN-GB", "ca-ES": "CA", "ru-RU": "RU", "uk-UA": "UK-UA" };
export const shortLang = (code) => SHORT_LANG[code] || (code || "").toUpperCase();

export const STATUS_META = {
  updated: { label: "Actualizada", Icon: Check, color: "text-[#6E8B3D]", bg: "bg-[#EEF6E1] border-[#6E8B3D] text-[#3F5A1E]" },
  outdated: { label: "Desactualizada desde la última modificación del español", short: "Desactualizada", Icon: AlertTriangle, color: "text-amber-500", bg: "bg-amber-50 border-amber-400 text-amber-800" },
  missing: { label: "Sin traducir", Icon: X, color: "text-red-600", bg: "bg-red-50 border-red-300 text-red-700" },
};

export function statusTitle(st) {
  if (!st) return "";
  const m = STATUS_META[st.status] || STATUS_META.missing;
  return m.label + (st.reviewed ? " · Revisada manualmente" : "");
}

export function LangStatusIcon({ st, size = 11 }) {
  if (!st) return null;
  const m = STATUS_META[st.status] || STATUS_META.missing;
  return (
    <span className="inline-flex items-center gap-0.5" data-testid={`lang-status-${st.status}`}>
      <m.Icon size={size} className={m.color} strokeWidth={3} />
      {st.reviewed && <Pencil size={size - 2} className="opacity-70" />}
    </span>
  );
}

export function StatusPill({ st, testid }) {
  if (!st) return null;
  const m = STATUS_META[st.status] || STATUS_META.missing;
  return (
    <span data-testid={testid} title={statusTitle(st)}
      className={`inline-flex items-center gap-1 border px-2 py-0.5 font-mono text-[10px] uppercase tracking-wider ${m.bg}`}>
      <m.Icon size={10} strokeWidth={3} /> {m.short || m.label}
      {st.reviewed && <span className="inline-flex items-center gap-0.5 ml-1 pl-1 border-l border-current/30"><Pencil size={9} /> Revisada</span>}
    </span>
  );
}

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("es", { dateStyle: "short", timeStyle: "short" }) : "—");
